import { createSlice } from '@reduxjs/toolkit'
import {
  addSubDomain,
  deleteSubDomain,
  getSubDomainById,
  getSubDomainbyId,
  getSubDomainbySecurityControls,
  getSubDomains,
  getSubDomainsBySecurityControlIdAndActionId,
  updateSubDomain,
} from './subDomainActions'
import { SubDomain, SubDomainResponse } from '../../types/subDomainTypes'

interface SubDomainState {
  subDomains: SubDomain[]
  loading: boolean
  subDomain: SubDomain | null
  error: string | null
  addedSubDomain: SubDomain | null
  updatedSubDomain: SubDomain | null
  SubDomainResponse: SubDomainResponse | null
  subDomainsbySecurityControls: SubDomain[]
  subDomainsbySecurityControlsAndActionId: SubDomain[]
}

const initialState: SubDomainState = {
  subDomains: [],
  loading: false,
  error: null,
  addedSubDomain: null,
  subDomain: null,
  updatedSubDomain: null,
  SubDomainResponse: null,
  subDomainsbySecurityControls: [],
  subDomainsbySecurityControlsAndActionId: [],
}

export const subDomainSlice = createSlice({
  name: 'subdomains',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSubDomains.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getSubDomains.fulfilled, (state, action) => {
        state.loading = false
        state.SubDomainResponse = {
          subDomains: action.payload.subDomains,
          totalPages: action.payload.totalPages ?? 0,
          total: action.payload.total ?? 0,
        }
      })
      .addCase(getSubDomains.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getSubDomainById.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getSubDomainById.fulfilled, (state, action) => {
        state.loading = false
        state.subDomain = action.payload
      })
      .addCase(getSubDomainById.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || 'Something went wrong'
      })
      .addCase(deleteSubDomain.fulfilled, (state, action) => {
        state.loading = false
        const deletedSubDomainId = action.meta.arg

        if (state.SubDomainResponse) {
          state.SubDomainResponse.subDomains = (
            state.SubDomainResponse.subDomains ?? []
          ).filter((subDomain) => subDomain._id !== deletedSubDomainId)

          state.SubDomainResponse.total = state.SubDomainResponse.total ?? 0
          state.SubDomainResponse.totalPages =
            state.SubDomainResponse.totalPages ?? 0
          state.SubDomainResponse.currentPage =
            state.SubDomainResponse.currentPage ?? 0
        }
      })
      .addCase(addSubDomain.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addSubDomain.fulfilled, (state, action) => {
        state.loading = false
        state.addedSubDomain = action.payload
        state.subDomains.push(action.payload)
      })
      .addCase(addSubDomain.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(updateSubDomain.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateSubDomain.fulfilled, (state, action) => {
        state.loading = false
        state.updatedSubDomain = action.payload
      })
      .addCase(updateSubDomain.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getSubDomainbyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getSubDomainbyId.fulfilled, (state, action) => {
        state.loading = false
        state.subDomain = action.payload
      })
      .addCase(getSubDomainbyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getSubDomainbySecurityControls.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(getSubDomainbySecurityControls.fulfilled, (state, action) => {
        state.loading = false
        state.subDomainsbySecurityControls = action.payload
      })
      .addCase(getSubDomainbySecurityControls.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getSubDomainsBySecurityControlIdAndActionId.pending, (state) => {
        state.loading = true
        state.error = null
      })

      .addCase(
        getSubDomainsBySecurityControlIdAndActionId.fulfilled,
        (state, action) => {
          state.loading = false
          state.subDomainsbySecurityControlsAndActionId = action.payload
        }
      )
      .addCase(
        getSubDomainsBySecurityControlIdAndActionId.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )
  },
})

export default subDomainSlice.reducer
